module.exports = __webpack_public_path__ + "static/tests-mockup.42a97acd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tests-mockup.png
// module id = 550
// module chunks = 35783957827783